const translations = {
  ClassCourses: {
    BannerTitle: '',
    InitialBreadcrumb: 'My Content',
    InitialBreadcrumb_plural: 'My Content'
  },
  ClassDetails: {
    BannerTitle: '',
    InitialBreadcrumb: 'My Content',
    InitialBreadcrumb_plural: 'My Content'
  },
  Login: {
    buttonSignUpLabel: 'Sign Up',
    forgotPassword: 'Forgot password',
    loginLogoLabel: 'Logo: Cognia®'
  },
  NavigationService: {
    InitialBreadcrumb: 'My Content',
    InitialBreadcrumb_plural: 'My Content'
  },
  StudentDashboard: {
    BookLabel: 'My Content',
    WelcomeLabel: 'Welcome,'
  },
  StudentTopNav: {
    BookLabel: 'My Content'
  },
  TeacherDashboard: {
    WelcomeLabel: 'Welcome,'
  }
};

export default translations;
